import React from "react"
import { useTranslation } from "react-i18next"
import { motion, AnimatePresence } from "framer-motion"

const BulkActionBar = ({
  count,
  bulkRef,
  bulkBtnRef,
  showBulkMenu,
  setShowBulkMenu,
  onDeleteClick,
  onDeselectAll,
  setBulkMenuPos,
}) => {
  const { t } = useTranslation()
  return (
    <motion.div
      key="bulk-bar"
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
      style={{ overflow: "hidden" }}
    >
      <div className="px-3 sm:px-5 py-2.5 bg-indigo-50 border-b border-indigo-100 flex items-center gap-2 sm:gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-indigo-600 flex items-center justify-center flex-shrink-0">
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="text-xs font-semibold text-indigo-700">
            {t("filter.selected")}: {count}
          </span>
        </div>
        <div className="w-px h-4 bg-indigo-200 hidden sm:block" />
        <div ref={bulkRef}>
          <button
            ref={bulkBtnRef}
            onClick={() => {
              if (!showBulkMenu && bulkBtnRef.current) {
                const r = bulkBtnRef.current.getBoundingClientRect()
                setBulkMenuPos({
                  top: r.bottom + window.scrollY + 4,
                  left: r.left + window.scrollX,
                })
              }
              setShowBulkMenu((v) => !v)
            }}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-600 text-white rounded-lg text-xs font-medium hover:bg-indigo-700 transition-all"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            <span className="hidden sm:inline">{t("admin.change_status")}</span>
            <span className="sm:hidden">{t("requests.status")}</span>
            <motion.svg
              animate={{ rotate: showBulkMenu ? 180 : 0 }}
              transition={{ duration: 0.18 }}
              className="w-3 h-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </motion.svg>
          </button>
        </div>
        <button
          onClick={onDeleteClick}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-red-200 text-red-600 rounded-lg text-xs font-medium hover:bg-red-50 transition-all"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          <span className="hidden sm:inline">{t("admin.delete_selected")}</span>
          <span className="sm:hidden">{t("admin.deleted")}</span>
        </button>
        <button
          onClick={onDeselectAll}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-indigo-500 hover:text-indigo-700 rounded-lg text-xs font-medium hover:bg-indigo-100 transition-all ml-auto"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          <span className="hidden sm:inline">{t("admin.deselect_all")}</span>
        </button>
      </div>
    </motion.div>
  )
}

export default BulkActionBar
